module.exports = __webpack_public_path__ + "static/media/DavidWiseman.60925a40.png";